module.exports = __webpack_public_path__ + "img/download.75779cb9.png";